import * as d3 from "d3";
import {
    colonAnnotation,
    DEFAULT_AXIS_FONT_SIZE,
    DEFAULT_AXIS_LABEL_FONT_SIZE,
    inrFormatter,
    numberFormat,
    colourScheme,
    responsivefy,
   generateDownloadData, contextMenu, axisTextDim1
} from '../functions'

export default function (chart, divId, vizName,resData, filterParam, checkbox, gridflag) {
    const defaultSize = true
    const defaultChartLayout = {
        width: 250,
        height: 600,
        margin: { top: 30, right: 100, bottom: 100, left: 150 }
    }
    const chartWidth = defaultSize ? defaultChartLayout.width : chart.width
    const chartHeight = defaultSize ? defaultChartLayout.height : chart.height
    const chartMargin = defaultSize ? defaultChartLayout.margin : chart.margin

    var size = defaultSize ? DEFAULT_AXIS_FONT_SIZE : chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = (defaultSize ? DEFAULT_AXIS_LABEL_FONT_SIZE : chart.axisLabelFontSize) + "px"
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    // Scales. Note the inverted domain fo y-scale: bigger is up!
    // var x1Scale = d3.scaleLinear().range([0, chartWidth]);
    // var y1Scale = d3.scaleBand().rangeRound([chartHeight, 0]).padding(0.002)
    // var left1 = 4
    // var x1AxisLabel = d3.axisBottom(x1Scale)
    // var y1AxisLabel = d3.axisLeft(y1Scale)
    console.log("checkbox", checkbox, gridflag);


    // axios.post(url, filterParam).then(res => {
        let data = resData
        //  data.sort((a, b) => b.metric1 - a.metric1);
        console.log("dataa", data);


        // Data is nested by country
        var categories = d3.nest()
            .key(function (d) {
                return d.dim2_name;
            })
            .entries(data);

        {
            d3.select(divId).selectAll("*").remove();
            d3.select("tooltip" + divId.id).remove();

            const tooltip = d3.select(divId).append('div')
                .attr('class', 'tooltip')
                .attr('style', 'position: absolute; opacity: 0;');

            const yScaleShared = d3.scaleBand()
                .domain(data.map(d => d.dim3_name))
                .range([0, chartHeight])
                .padding(0.1);

            categories.forEach(cat => {
                cat.maxNumber = d3.max(cat.values, d => d.metric1);
            });

            const leftAxisAreaWidth = chartMargin.left + 40;
            const gap = 20;
            const perCategoryWidth = chartWidth + chartMargin.right;
            const totalChartsWidth = perCategoryWidth * categories.length + gap * Math.max(categories.length - 1, 0);
            const rootWidth = leftAxisAreaWidth + totalChartsWidth + chartMargin.right;
            const rootHeight = chartHeight + chartMargin.top + chartMargin.bottom;

            const rootSvg = d3.select(divId)
                .append("svg")
                .attr("width", rootWidth)
                .attr("height", rootHeight)
                .call(responsivefy);

            const rootGroup = rootSvg.append("g")
                .attr("transform", `translate(0,${chartMargin.top})`);

            rootGroup.append("g")
                .attr("transform", `translate(${chartMargin.left},0)`)
                .call(d3.axisLeft(yScaleShared))
                .selectAll("text")
                .style("font-size", fontSize)
                .style("text-anchor", "end")
                .attr('dx', "-0.4em")
                .attr("dy", yScaleShared.bandwidth() / 6 + "px")
                .text(axisTextDim1);

            rootGroup.append('text')
                .attr('transform', 'rotate(-90)')
                .attr('y', 20)
                .attr('x', 0 - (chartHeight / 2))
                .attr("dy", ".71em")
                .style("text-anchor", "middle")
                .style('fill', fontColor)
                .style('font-size', axisLabelFontSize)
                .text(chart.y1AxisDisplayName);

            const chartsRoot = rootGroup.append("g")
                .attr("transform", `translate(${leftAxisAreaWidth},0)`);

            categories.forEach((category, i) => {
                const groupX = i * (perCategoryWidth + gap);
                const localSvg = chartsRoot.append("g")
                    .attr("transform", `translate(${groupX},0)`);

                const minValue = d3.min(category.values, d => d.metric1);
                const maxValue = d3.max(category.values, d => d.metric1);

                const localXScale = d3.scaleLinear()
                    .domain([minValue < 0 ? minValue : 0, maxValue])
                    .range([0, chartWidth]);

                const xAxis = d3.axisBottom(localXScale).tickFormat(numberFormat).ticks(5);

                const metric1ColorScale = d3.scaleSequential(colourScheme(category.values[0].dim4_name)).domain([0, category.maxNumber]);
                const metric2ColorScale = d3.scaleSequential(colourScheme(category.values[1]?.dim4_name ?? category.values[0]?.dim4_name)).domain([0, category.maxNumber]);
                const metric3ColorScale = d3.scaleSequential(colourScheme(category.values[2]?.dim4_name ?? category.values[0]?.dim4_name)).domain([0, category.maxNumber]);
                const metric4ColorScale = d3.scaleSequential(colourScheme(category.values[3]?.dim4_name ?? category.values[0]?.dim4_name)).domain([0, category.maxNumber]);

                localSvg.append("g")
                    .attr("class", "x axis")
                    .attr("transform", `translate(0,${chartHeight})`)
                    .call(xAxis)
                    .selectAll('text')
                    .style('font-size', fontSize)
                    .style('text-anchor', 'end')
                    .attr('dx', '-.1em')
                    .attr('transform', 'rotate(-50)');

                localSvg.append("text")
                    .attr("transform", `translate(${chartWidth / 2},${chartHeight + chartMargin.top + 60})`)
                    .style("text-anchor", "middle")
                    .attr("font-size", axisLabelFontSize)
                    .attr("fill", fontColor)
                    .text(category.key);

                localSvg.append("text")
                    .attr("transform", `translate(${chartWidth / 2},${chartMargin.top - 40})`)
                    .style("text-anchor", "middle")
                    .attr("font-size", axisLabelFontSize)
                    .attr("fill", fontColor)
                    .text(category.key);

                if (gridflag) {
                    localSvg.append("g")
                        .attr("class", "grid")
                        .attr("transform", `translate(0,${chartHeight})`)
                        .call(d3.axisBottom(localXScale).tickSize(-chartHeight).tickFormat(""));

                    localSvg.append("g")
                        .attr("class", "grid")
                        .call(d3.axisLeft(yScaleShared).tickSize(-chartWidth).tickFormat(""));
                }

                localSvg.selectAll(".barmpc")
                    .data(category.values)
                    .enter()
                    .append("rect")
                    .attr("class", "barmpc")
                    .attr("x", '0.1em')
                    .attr("y", d => yScaleShared(d.dim3_name))
                    .attr("width", d => localXScale(d.metric1))
                    .attr("height", yScaleShared.bandwidth() / 1.7)
                    .attr("fill", d => {
                        if (d.dim2_name === chart.x1MetricTooltip) return metric3ColorScale(d.metric1);
                        if (d.dim2_name === chart.y1MetricTooltip) return metric1ColorScale(d.metric1);
                        if (d.dim2_name === chart.x2MetricTooltip) return metric4ColorScale(d.metric1);
                        return metric2ColorScale(d.metric1);
                    })
                    .on("mousemove", function (d) {
                        tooltip.transition().duration(200).style("opacity", .9);
                        tooltip.html(`${chart.y1AxisDisplayName}${colonAnnotation}${d.dim3_name}<br/>${d.dim2_name}${colonAnnotation}${inrFormatter(d.metric1)}`)
                            .style("left", (d3.event.clientX - divId.getBoundingClientRect().left) + "px")
                            .style("top", (d3.event.clientY - divId.getBoundingClientRect().top) + "px");
                    })
                    .on("mouseout", function () {
                        tooltip.transition().style("opacity", 0);
                    })
                    .on('contextmenu', function (d) {
                        const clickedData = {
                            [chart.insightNavigator.realDataFieldNames.x2RealDataFieldName]: [d.dim3_name],
                            [chart.insightNavigator.realDataFieldNames.y1RealDataFieldName]: [d.dim2_name]
                        };
                        const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);
                        contextMenu(menuItems).call(this, clickedData);
                        d3.event.preventDefault();
                    });

                localSvg.selectAll(".barmpc-text")
                    .data(category.values)
                    .enter()
                    .append("text")
                    .attr("class", "barmpc-text")
                    .text(d => numberFormat(d.metric1))
                    .attr("x", d => localXScale(d.metric1) / 2.3)
                    .attr("y", d => yScaleShared(d.dim3_name) + yScaleShared.bandwidth() / 2.5)
                    .style("font-size", fontSize)
                    .style("font-weight", "bold")
                    .style("fill", d => d.metric1 > category.maxNumber / 2 ? "white" : "black");
            });
        }

    // })
}

